import React, { useState } from 'react';
import { Box } from '@mui/material';
import Swal from 'sweetalert2';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { LoadingButton } from '@mui/lab';

const ActionButton = ({ project_code, onApprove, onReject }) => {
  const [loadingAction, setLoadingAction] = useState(null);

  const handleConfirm = async (actionName, callback, status) => {
    const result = await Swal.fire({
      title: `CONFIRM ${actionName.toUpperCase()}?`,
      input: 'textarea',
      inputLabel: `Do you want to ${actionName.toLowerCase()} this applicant?`,
      inputPlaceholder: 'Describe your note here...',
      inputAttributes: {
        'aria-label': 'Write your note here',
      },
      showCancelButton: true,
      confirmButtonText: `YES, ${actionName.toUpperCase()} IT!`,
      cancelButtonText: 'CANCEL',
      confirmButtonColor:
        actionName === 'Approve'
          ? '#2e7d32'
          : actionName === 'Reject'
          ? '#d32f2f'
          : '#ed6c02',
    });

    if (result.isConfirmed) {
      const notes = result.value || '';
      try {
        setLoadingAction(status);
        await callback({ project_code, notes, status });
      } finally {
        setLoadingAction('');
      }
    }
  };

  return (
    <Box display="flex" gap={1}>
      <LoadingButton
        variant="contained"
        color="success"
        startIcon={<CheckCircleOutlineIcon />}
        loading={loadingAction === 3}
        disabled={loadingAction !== null}
        onClick={() => handleConfirm('Approve', onApprove, 3)}
      >
        APPROVE
      </LoadingButton>

      <LoadingButton
        variant="contained"
        color="error"
        startIcon={<HighlightOffIcon />}
        loading={loadingAction === 999}
        disabled={loadingAction !== null}
        onClick={() => handleConfirm('Reject', onReject, 999)}
      >
        REJECT
      </LoadingButton>
    </Box>
  );
};

export default ActionButton;
